import * as userService from '@/services/user.service';

const getUserProfile = async () => {
  const response = await userService.getUserProfile();
  return response.data;
};

export default getUserProfile;
